// @flow strict-local
// $FlowFixMe[untyped-type-import]
import typeof IndexStore from 'src/stores';
import type {Dispatch, ReduxStore} from 'src/reducers';
import * as React from 'react';
import logger from 'src/utils/logger';
import {
  isLanguageSupported,
  getBrowserLanguage,
} from 'src/utils/language-support';
import {Provider} from 'react-redux';
// $FlowFixMe[untyped-import]
import FluxRoot from 'src/flux/root.jsx';
import {CircularLoader} from '@spaced-out/ui-design-system/lib/components/CircularLoader';

import {StandaloneApp as BookingApp} from './booking/standalone.jsx';
import {WindowWidthProvider} from 'src/components/lib/responsive.jsx';
import I18nContext from 'src/contexts/i18n-context';
//$FlowFixMe[untyped-import]
import labelI18nInstance, {
  //$FlowFixMe[untyped-import]
  ensureInitialized,
} from 'src/components/lib/i18n/new-i18n';
import {getAgencyConfig} from 'src/action-creators/agency';
import {getReleaseFlags} from 'src/action-creators/product-flags';

import 'src/components/app.global.css';
import styles from 'src/components/app.css';


const SchedulerApp = ({
  agentId,
  templateSuffix,
  reduxStore,
  senseStore,
}: {
  agentId: string,
  templateSuffix: string,
  reduxStore: ReduxStore,
  // $FlowFixMe[value-as-type]
  senseStore: IndexStore,
}): React.Node => {
  const [i18nState, setI18nState] = React.useState(labelI18nInstance);
  const [i18nReady, setI18nReady] = React.useState(false);
  const {i18NEnableLanguageSupport: isLanguageSupportEnabled} =
    reduxStore.getState().agency.config;

  // clean up localStorage if language support is disabled
  if (!isLanguageSupportEnabled) {
    try {
      localStorage.removeItem('selectedLanguage');
    } catch (e) {
      logger.error('Error removing selectedLanguage from localStorage', e);
    }
  }
  let localStorageSelectedLanguage = null;
  try {
    localStorageSelectedLanguage = localStorage.getItem('selectedLanguage');
  } catch (e) {
    logger.error('Error getting selectedLanguage from localStorage', e);
  }

  const selectedLanguageFromLocalStorage = isLanguageSupported(
    localStorageSelectedLanguage || '',
  )
    ? localStorageSelectedLanguage
    : null;

  const browserDetectedLanguage = getBrowserLanguage();

  const finalResolvedLanguage = isLanguageSupportEnabled
    ? selectedLanguageFromLocalStorage || browserDetectedLanguage
    : null;

  React.useEffect(() => {
    const initializeI18n = async () => {
      try {
        await ensureInitialized(finalResolvedLanguage); // ensure translations are initialized
        setI18nReady(true);
      } catch (error) {
        console.error('Error initializing translations:', error);
        setI18nReady(true); // allow app to proceed even if translations fail
      }
    };

    initializeI18n();

    const handleLanguageChanged = () => {
      setI18nState({...labelI18nInstance});
    };

    labelI18nInstance.on('languageChanged', handleLanguageChanged);

    return () => {
      labelI18nInstance.off('languageChanged', handleLanguageChanged);
    };
  }, []);

  if (!i18nReady) {
    return (
      <div className={styles.i18nLoader}>
        <CircularLoader size="large" />
      </div>
    );
  }

  return (
    <Provider store={reduxStore}>
      <FluxRoot store={senseStore}>
        <div className={styles.container}>
          <div className={styles.body}>
            <WindowWidthProvider>
              <I18nContext.Provider value={{labelI18nInstance}}>
                <BookingApp agentId={agentId} templateSuffix={templateSuffix} />
              </I18nContext.Provider>
            </WindowWidthProvider>
          </div>
        </div>
      </FluxRoot>
    </Provider>
  );
};

export default SchedulerApp;

export const schedulerDependencies = ({
  dispatch,
}: {
  dispatch: Dispatch,
}): Promise<Array<mixed>> => {
  return Promise.all([
    dispatch(getAgencyConfig()),
    dispatch(getReleaseFlags()),
  ]);
};
